export default __webpack_public_path__ + "static/media/56_3_0.88448bcd.png";